import bus from "../bus";
import { mastheadPlayerEvents, playerEvents } from "../player/events";
import { mergeStateAction } from "../utilities/hyperapp";

let intersectionObserver;

export default {
  destroy: () => ({ destroyed: true }),
  onCreate: () => (state, actions) => {
    bus.on(playerEvents.STATUS_CHANGE, actions.onPlayerStatusChange);
    bus.on(mastheadPlayerEvents.WIGGLE, actions.wiggle);
    bus.emit(playerEvents.REQUEST_STATUS);
    const mastheadPlayerElement = document.querySelector(".masthead__player-wrapper");
    intersectionObserver = new IntersectionObserver(actions.onIntersectionChange, {
      threshold: 1,
      scrollMargin: `${mastheadPlayerElement.offsetTop}px`,
    });
    intersectionObserver.observe(mastheadPlayerElement.offsetParent);
  },
  onDestroy: () => (state, actions) => {
    bus.removeListener(
      playerEvents.STATUS_CHANGE,
      actions.onPlayerStatusChange
    );
    bus.removeListener(mastheadPlayerEvents.WIGGLE, actions.wiggle);
    intersectionObserver.disconnect();
    intersectionObserver = null;
  },
  onPlayerStatusChange: ({
    currentItemPlayerItemID,
    currentItemReady,
    currentItemLive,
    currentItemTitle,
    currentItemSubtitle,
    isOpen,
    status
  }) => mergeStateAction({
    isNull: currentItemPlayerItemID === "playable-null",
    isPlaying: status === "playing",
    isLive: currentItemLive,
    isReady: currentItemReady,
    title: currentItemTitle,
    isOpen,
    subtitle: currentItemSubtitle,
  }),
  onIntersectionChange: (entries) => (state, actions) => {
    const entry = entries[0];
    // don't count it if it's offscreen to the bottom
    // (which can happen when full page special mode banner is displayed)
    const offscreen = !entry.isIntersecting && entry.intersectionRect.y < 0;
    return { offscreen };
  },
  setWiggle: ({ wiggle }) => ({ wiggle }),
  wiggle: () => (state, actions) => {
    if (state.wiggleTimer) {
      clearTimeout(state.wiggleTimer);
    }
    return {
      ...state,
      wiggle: true,
      wiggleTimer: setTimeout(() => {
        actions.setWiggle(false);
      }, 1000)
    };
  }
};
